import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { downloadUserContacts, getUserContacts } from "../redux/userSpeaker/userSpeakerSlice";
import { toast } from "react-toastify";

const MyContacts = ({ userId }) => {

  const dispatch = useDispatch();
  const { contacts, loading, userInfo } = useSelector((state) => state.speaker);

  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLocationId, setSelectedLocationId] = useState("");

  const locationOptions = userInfo?.eventLocations || [];

  useEffect(() => {
    if (!selectedLocationId && locationOptions.length) {
      setSelectedLocationId(locationOptions[0].id);
    }
  }, [selectedLocationId, locationOptions]);

  useEffect(() => {
    if (userId && selectedLocationId) {
      dispatch(getUserContacts({
        id: userId,
        locationId: selectedLocationId,
      }));
    }
  }, [dispatch, userId, selectedLocationId]);

  /* SEARCH FILTER */

  const filteredContacts = contacts?.filter((contact) => {

    const name =
      `${contact.firstName || ""} ${contact.lastName || ""}`.toLowerCase();

    return (
      name.includes(search.toLowerCase()) ||
      contact.email?.toLowerCase().includes(search.toLowerCase())
    );
  });

  /* PAGINATION */

  const totalEntries = filteredContacts?.length || 0;

  const totalPages = Math.ceil(totalEntries / entries);

  const startIndex = (currentPage - 1) * entries;
  const endIndex = startIndex + entries;

  const paginatedContacts = filteredContacts?.slice(startIndex, endIndex);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [filteredContacts]);

  return (
    <div className="card h-100 p-0 radius-12">

      {/* HEADER CONTROLS */}

      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">

        <div className="d-flex align-items-center flex-wrap gap-3">

          <span className="text-md fw-medium text-secondary-light">
            Show
          </span>

          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={entries}
            onChange={(e) => {
              setEntries(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>

        </div>

        <div className="d-flex align-items-center gap-2 flex-wrap">

          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={selectedLocationId}
            onChange={(e) => {
              setSelectedLocationId(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">Select Location</option>
            {locationOptions.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>

          <form className="navbar-search">
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
            <Icon icon="ion:search-outline" className="icon" />
          </form>

          <button
            className="btn btn-success d-flex align-items-center gap-1"
            onClick={() => {
              if (!selectedLocationId) {
                toast.error("Please select location");
                return;
              }

              dispatch(downloadUserContacts({
                id: userId,
                locationId: selectedLocationId,
              }));
            }}
          >
            <Icon icon="mdi:file-excel-outline" />
            Download
          </button>

        </div>

      </div>

      {/* TABLE */}

      <div className="card-body p-12">

        <div className="table-responsive scroll-sm">

          <table className="table bordered-table sm-table mb-0">

            <thead>
              <tr>
                <th>S.L</th>
                <th>Profile</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Company</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>

              {loading && (
                <tr>
                  <td colSpan="6" className="text-center">
                    Loading...
                  </td>
                </tr>
              )}

              {!loading && paginatedContacts?.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">
                    No contacts found
                  </td>
                </tr>
              )}

              {paginatedContacts?.map((contact, index) => {
                const user = contact.user2 || contact;

                return (
                <tr key={contact.contactId || user.id}>

                  <td>{startIndex + index + 1}</td>

                  <td>
                    <img
                      src={user.profilePicture ? `${process.env.REACT_APP_API_URL}/${user.profilePicture}` : '/assets/images/user.png'}
                      alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </td>
                  <td>
                    {user.fullName || "-"}
                  </td>

                  <td>{user.email || "-"}</td>

                  <td>{user.phone || "-"}</td>

                  <td>{user.Company?.name || "-"}</td>


                  <td className="text-center">

                    <div className="d-flex align-items-center gap-10 justify-content-center">

                      <button className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle">
                        <Icon icon="lucide:eye" />
                      </button>

                      {/* <button className="bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle">
                        <Icon icon="fluent:delete-24-regular" />
                      </button> */}

                    </div>

                  </td>

                </tr>
                );
              })}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">

          <span>
            Showing {startIndex + 1} to{" "}
            {Math.min(endIndex, totalEntries)} of {totalEntries} entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">

            <li className="page-item">

              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
              >
                <Icon icon="ep:d-arrow-left" />
              </button>

            </li>

            {[...Array(totalPages)].map((_, i) => (

              <li key={i} className="page-item">

                <button
                  onClick={() => setCurrentPage(i + 1)}
                  className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1
                      ? "bg-primary-600 text-white"
                      : "bg-neutral-200 text-secondary-light"
                    }`}
                >
                  {i + 1}
                </button>

              </li>

            ))}

            <li className="page-item">

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
              >
                <Icon icon="ep:d-arrow-right" />
              </button>

            </li>

          </ul>

        </div>

      </div>

    </div>
  );
};

export default MyContacts;
